import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLComponentTypeManifest } from '../interfaces';
import { VALTYPES } from '../../../../data/interfaces';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { color } from '../../../visual-analytics/helpers/colors';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { ETLDryRunObjectTableAddColumn } from '../utils';
import { addDryRunObjectTable } from '../../utils';
import { CONFIGPARAMTYPES } from '../../../visual-analytics/helpers/configParams';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'id', 'ID', 'Unique identifier of the publication', VALTYPES.STRING);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'authors', 'Authors', 'The list of authors', VALTYPES.MULTICAT);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'title', 'Title', 'The title of publication', VALTYPES.STRING);
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'publication_year',
    'Publication year',
    'The year the article was published',
    VALTYPES.NUMBER,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'journal_name',
    'Journal name',
    'The full name of the journal the article was published in',
    VALTYPES.CATEGORICAL,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'abstract',
    'Abstract',
    'The abstract of the publication',
    VALTYPES.TEXT,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'mesh_terms',
    'MeSH',
    'MeSH (Medical Subject Headings) is the NLM controlled vocabulary thesaurus used for indexing articles for PubMed.',
    VALTYPES.MULTICAT,
  );
  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'publication_type',
    'publication type',
    'The type of publication',
    VALTYPES.MULTICAT,
  );

  return {
    abort: false,
  };
}

export const manifestETLQueryPubMed: TpETLComponentTypeManifest = {
  id: 'QueryPubMed',
  name: 'Query PubMed',
  description: 'Get publications from the PubMed database',
  categoryId: 'source',
  color: color(0, 128, 255),
  icon: <FontAwesomeIcon icon={['fas', 'book']} />,
  inputs: [],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the retrieved publications',
      columns: [],
    },
  ],
  params: [
    {
      id: 'query',
      name: 'Query',
      description: 'Query used to retrieve publications.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Text },
    },
    {
      id: 'generateQuery',
      name: 'Generate Query',
      description:
        'Set to true to generate a query based on the input parameters. Leave False if a Pubmed query is provided.',
      paramType: {
        configParamTypeId: CONFIGPARAMTYPES.Boolean,
        defaultValue: false,
        label: 'Generate Query',
      },
    },
    {
      id: 'max_results',
      name: 'Max Publications',
      description:
        'Maximum publications to fetch from Pubmed. Please consider resource costs and intended use when selecting this value. ' +
        'Is a large number of results really useful, can the query be optimized? ' +
        'A reasonable limit is 1k or max 10k, but for some rare situations a theoretical limit of 150k articles could be selected.',
      paramType: {
        configParamTypeId: CONFIGPARAMTYPES.Numerical,
        minVal: 100,
        maxVal: 150_000,
        intervalStep: 50,
        defaultValue: 1000,
      },
    },
  ],
  performDryRun,
};
